import { ClientErrorRegistry } from "./client-error";
import { SystemErrorRegistry } from "./system-error";
export class AscendErrorUtils {
    static isAscendError(e) {
        return !!e.isAscendError;
    }
    static isClientError(e) {
        return (AscendErrorUtils.isAscendError(e) &&
            !!e.isClientError);
    }
    static isSystemError(e) {
        return (AscendErrorUtils.isAscendError(e) &&
            !!e.isSystemError);
    }
}
export const AscendErrorRegistry = {
    ...ClientErrorRegistry,
    ...SystemErrorRegistry,
};
//# sourceMappingURL=ascend-error.js.map